import { AUTOSTART_PARAM } from '../plugins/NextEpisodeOverlay/nextEpisodeOverlayPlugin'
import { PreSetupHook } from '../urPlayerManager'

const autostart: PreSetupHook = () => {
  if (window.location.search.includes(AUTOSTART_PARAM)) {
    return { autostart: 'viewable' }
  }

  return null
}

export default autostart
